import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { styled as styling } from "@mui/material/styles";
import withTheme from "@mui/styles/withTheme";
import styled from "styled-components";
import Color from "../../assets/colors";

// Image Components //
export const ImageStyled = withTheme(styled.img`
  && {
    width: 35%;
    min-width: ${(props) => (props.$maintenance === "true" ? "16rem" : null)};
    max-width: ${(props) => (props.$maintenance === "true" ? "25%" : null)};
  }
`);

export const Logo = styling("img")({
  width: "inherit",
});

// Typography Components //
export const TitleStyled = styling(Typography)({
  fontWeight: "bold",
  marginTop: "12px",
});

export const SubtitleStyled = styling(Typography)({
  marginTop: "12px",
});

// Grid Components //
export const GridStyled = styling(Grid)((props) => ({
  height: "20px",
  width: "140px",
  cursor: "pointer",

  [props.theme.breakpoints.down(780)]: {
    marginLeft: "7.5%",
  },
}));

export const GridContent = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  textAlign: "center",
  height: "100vh",
  justifyContent: "center",

  [props.theme.breakpoints.down(480)]: {
    marginTop: "90px",
  },
  [props.theme.breakpoints.down(360)]: {
    marginTop: "180px",
  },
}));

export const ButtonContainer = styling(Grid)({
  display: "flex",
  alignItems: "center",
  width: "100%",
  flexWrap: "wrap",
  justifyContent: "center",
});

// Appbar Components //
export const AppBarStyled = styling(AppBar)({
  color: Color.hiredlyPurple,
  backgroundColor: Color.white,
});

// Link Component //
export const LinkStyled = styling(Link)({
  textDecoration: "none",

  "&:hover": {
    textDecoration: "none",
  },
});
